<template>
  <section>
    <v-card dark class="gradient__withAnimation">
      <particles>
        <home-toolbar></home-toolbar>
        <banner :item="banner"></banner>
      </particles>
    </v-card>

    <section-content :item="content"></section-content>

    <footer-component></footer-component>
  </section>
</template>

<script>
import store from '@/store'
import Banner from './template/Banner'
import SectionContent from './template/Content'
import banner from '@/modules/CDA/Programmes/assets/images/governance.svg'

export default {
  store,
  name: 'Governance',

  components: {
    Banner,
    SectionContent,
  },

  data () {
    return {
      banner: {
        thumbnail: banner,
        title: 'Cybersecurity Governance, Risk & Compliance (GRC)',
      },

      content: {
        md8: true,
        overview: '<p>This programme seeks to provide a step by step guide to develop a Cybersecurity GRC framework that will help organisations better protect their assets and reputation in the cyber risk environment.  Cyber attacks can be reduced if organisations take the necessary measures to proactively deal with cyber risks through effective GRC framework that includes robust control measures through policies, procedures and training. The programme explains how to establish systematic control functions, procedural execution and timely management reporting and how to build auditable trust into routine assurance of ICT operations.  It includes real world examples and cases to illustrate key concepts and issues for programme participants.</p>',

        outcome: '<p>By attending this programme, participants can be equipped with the knowledge, skills and toolkit to:</p> <ul><li>Design, develop and maintain a GRC framework geared towards creating a cyber resilient organisation</li><li>Better manage cybersecurity risks through robust control measures and standard operating procedures</li><li>Able to better manage cybersecurity audits and ensure compliance with laws and regulations</li><li>Enable organisations to be ready for cyber attacks in a structured and proactive manner from a human and cultural perspectives</li></ul>',

        outline: '<ol><li><strong>Strategies to deal with cybersecurity risks</strong><ol type="a"><li>Understand cyber risk environment</li><li>Cybersecurity planning (strategic, tactical, operational)</li><li>Technological developments (big data, analytics and artificial intelligence) impacting cybersecurity arena</li><li>Regulatory and compliance requirements</li><li>SWOT analysis</li></ol></li><li><strong>How to design and develop a cybersecurity GRC framework</strong><ol type="a"><li>Internal organisation culture</li><li>Cybersecurity risk management<ol type="a"><li>Evaluating risk appetite</li><li>Risk assessment and analysis</li><li>Risk management process<ol type="1"><li>Identify risks</li><li>Evaluate risks<ol type="1"><li>Determine impact severity</li><li>Determine risk levels</li></ol></li><li>Mitigate risks<ol type="1"><li>Avoid, limit or transfer</li></ol></li></ol></li></ol></li><li>Cybersecurity policies, procedures and control measures<ol type="a"><li>Cybersecurity control framework</li><li>Cybersecurity standards</li><li>Procedures</li><li>Auditing compliance</li><li>Baselines</li><li>Best practices</li></ol></li><li>Technology deployment<ol type="a"><li>Systems planning</li><li>System architecture</li><li>Control measures</li></ol></li><li> Testing<ol type="a"><li>Penetration testing</li><li>Vulnerability assessment</li><li>Incident response</li></ol></li><li>Monitoring </li><li>Evaluation</li><li>Business continuity and disaster recovery</li></ol></li><li><strong>Regulatory and Legal Compliance</strong><ol type="a"><li>Review of regulatory and legal environment</li><li>Legal and regulatory risk management framework</li><li>Accountability and reporting</li><li>Legal documentation</li><li>Legal standard operating procedures</li></ol></li><li><strong>Training and Capability Building</strong><ol type="a"><li>Cybersecurity leadership training</li><li>Competencies required</li><li>Grassroot support and rank and file training</li></ol></li><li><strong>Post Incident Management</strong><ol type="a"><li>Incident response plan</li><li>Forensic investigation</li></ol></li><li><strong>Communication</strong></li></ol>',

        audience: {
          showTargetAudience: true,
          items: [
            { icon: 'mdi-check-outline', title: 'C-suite and senior managers' },
            { icon: 'mdi-check-outline', title: 'Cybersecurity and IT professionals' },
            { icon: 'mdi-check-outline', title: 'Risk and compliance officers' },
            { icon: 'mdi-check-outline', title: 'Legal advisers (practitioners as well as in house counsels)' },
            { icon: 'mdi-check-outline', title: 'Business executives' },
            { icon: 'mdi-check-outline', title: 'Government officers in charge of cybersecurity issues' },
          ]
        }
      },
    }
  },
}
</script>
